import { DateTime } from 'luxon'
import type { ReportModels } from '@domain-group/realhub-backend-api-types'
const startOfMonth = DateTime.now().startOf('month')
const startOfLastMonth = startOfMonth.minus({ months: 1 })

const endDate: string = startOfMonth.toISODate()
const startDate: string = startOfLastMonth.toISODate()

const reportModels: ReportModels = {
  first_time_right_leaderboard: {
    defaultState: {
      chart_data_key: '',
      end_date: endDate,
      start_date: startDate,
    },
    requiredFields: [
    ],
  },
  template_rejections: {
    defaultState: {
      end_date: endDate,
      start_date: startDate,
    },
    requiredFields: [
    ],
  },
  active_projects: {
    defaultState: {
    },
    requiredFields: [
    ],
  },
}

export default reportModels
